import { EditableImg, EditableText } from '@smartfire/components';
import { BlockWrapper, defineBlock, smartProps, useEditor, useInspectorControl } from '@smartfire/js-block-engine';
import React from 'react';
import style from './block.module.scss';

const Inspector = React.lazy(() => import('./Inspector'));

const Block = ({ anchorId }) => {
    useInspectorControl(Inspector);
    const { isEditing } = useEditor();
    const Tag = BlockWrapper[isEditing ? 'Div' : 'A'];

    return (
        <Tag href={'#anchor-' + anchorId}>
            <div className={style.block}>
                <div className={style.content}>
                    <EditableImg className={style.icon} smartProp={'icon'} />
                </div>
                <EditableText className={style.title} tagName={'p'} smartProp={'title'} placeholder={'Titre'} />
            </div>
        </Tag>
    );
};

export default defineBlock({
    Block,
    smartProps: {
        icon: smartProps.picto,
        title: smartProps.string.withDefault(''),
        anchorId: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Icone Home hero',
        parent: ['smartfire/home-hero'],
    },
});
